// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__32Dl0","validationTips":"StatementDescriptor_validationTips__3pncV"};